export const iconFontAwesomeAutomotiveTruckFieldUn = (
	<i className="fa-solid fa-truck-field-un"></i>
);
